import { eachDayOfInterval, parseISO, format } from "date-fns";
import { DATE_FORMAT } from "../appointment-schedule.constants.js";
const fillEmptyDays = (workingTimes = [], employees = [], timePeriod) => employees.map(({ referenceId: employeeReferenceId }) => {
  const employeeData = workingTimes.find((workingTime) => workingTime.employeeReferenceId === employeeReferenceId);
  const dates = eachDayOfInterval({
    start: parseISO(timePeriod.start ?? ""),
    end: parseISO(timePeriod.end ?? "")
  });
  const updatedWorkingTimes = dates.map((day) => ({
    date: format(day, DATE_FORMAT),
    periods: []
  })).filter(
    ({ date }) => {
      var _a;
      return !employeeData || ((_a = employeeData.workingTimes) == null ? void 0 : _a.every(({ date: currentDate }) => currentDate !== date));
    }
  );
  return {
    employeeReferenceId,
    nonWorkingTimes: (employeeData == null ? void 0 : employeeData.nonWorkingTimes) ?? [],
    workingTimes: [...updatedWorkingTimes, ...(employeeData == null ? void 0 : employeeData.workingTimes) ?? []]
  };
});
export {
  fillEmptyDays
};
